module.exports = __webpack_public_path__ + "static/media/login-home.50f6e343.jpg";